import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]
  static outlets = ["source-streams-chart"]

  // Define parent-child relationships
  categoryMap = {
    'total_active': ['album', 'artist', 'collection', 'search', 'play_queue'],
    'total_programmed': ['editorial_playlist', 'user_playlist', 'radio', 'chart', 'algorithmic_playlist', 'your_dj']
  }

  connect() {
    // Initialize with all checkboxes checked by default
    this.checkboxTargets.forEach(checkbox => {
      if (!checkbox.hasAttribute('data-initialized')) {
        checkbox.checked = true
        checkbox.setAttribute('data-initialized', 'true')
      }
    })
  }

  toggle(event) {
    const checkbox = event.target
    const checkboxId = checkbox.id
    let sourceName = checkboxId.replace(/_/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')

    // If this is a parent checkbox (Total Active or Total Programmed), toggle all children
    if (this.categoryMap[checkboxId]) {
      this.toggleChildren(checkboxId, checkbox.checked)
    }

    // Notify the chart controller to update
    if (this.hasSourceStreamsChartOutlet) {
      this.sourceStreamsChartOutlet.toggleSeries(sourceName, checkbox.checked)
    }
  }

  toggleChildren(parentId, isChecked) {
    const childIds = this.categoryMap[parentId]
    if (!childIds) return

    childIds.forEach(childId => {
      const childCheckbox = document.getElementById(childId)
      if (childCheckbox && childCheckbox.checked !== isChecked) {
        childCheckbox.checked = isChecked

        // Trigger the chart update for each child
        let childSourceName = childId.replace(/_/g, ' ')
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')

        if (this.hasSourceStreamsChartOutlet) {
          this.sourceStreamsChartOutlet.toggleSeries(childSourceName, isChecked)
        }
      }
    })
  }

  getSelectedSources() {
    return this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => {
        return checkbox.id.replace(/_/g, ' ')
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      })
  }
}
